import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-modal-confirm-payment',
  templateUrl: './modal-confirm-payment.component.html',
  styleUrl: './modal-confirm-payment.component.scss'
})
export class ModalConfirmPaymentComponent {
  @Input() isVisible: boolean = false;
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  handleCancel() {
    this.cancel.emit();
  }

  handleConfirm() {
    this.confirm.emit();
  }
}
